import {
  getOnGoingHome,
  getOnGoingList,
  getDonationHistory,
  getListDonationsPlan,
  getOnGoingAnon,
  getDonationReceipt,
} from "@/services/donations";

const getters = {
  listOnGoingHome: (state) => state.listOnGoingHome,
  listOnGoingList: (state) => state.listOnGoingList,
  listDonationHistory: (state) => state.listDonationHistory,
  listDonationPlan: (state) => state.listDonationPlan,
  listOnGoingAnon: (state) => state.listOnGoingAnon,
  per_page: (state) => state.per_page,
};

const actions = {
  async requestOnGoingHome({ commit, rootGetters }) {
    commit("NotificationModule/TOGGLE_LOADING", true, { root: true });
    let returnRes = [];
    try {
      const response = await getOnGoingHome({
        tokenType: rootGetters["AuthModule/tokenType"],
        accessToken: rootGetters["AuthModule/accessToken"],
      });
      returnRes = response.data !== undefined ? response.data : [];
      commit("SET_LIST_ONGOING_HOME", returnRes);
      commit(
        "NotificationModule/SET_STATUS",
        { status: 200, message: ``, errorCode: null },
        { root: true },
      );
    } catch (err) {
      commit(
        "NotificationModule/SET_STATUS",
        { status: 400, message: `${err.data.message}`, errorCode: null },
        { root: true },
      );
    } finally {
      commit("NotificationModule/TOGGLE_LOADING", false, { root: true });
    }
    return returnRes;
  },
  async requestOnGoingList({ commit, rootGetters }) {
    commit("NotificationModule/TOGGLE_LOADING", true, { root: true });
    let returnRes = [];
    try {
      const response = await getOnGoingList({
        tokenType: rootGetters["AuthModule/tokenType"],
        accessToken: rootGetters["AuthModule/accessToken"],
      });
      returnRes = response.data !== undefined ? response.data : [];
      commit(
        "SET_LIST_ONGOING_LIST",
        response.data !== undefined ? response.data : [],
      );
      commit(
        "NotificationModule/SET_STATUS",
        { status: 200, message: ``, errorCode: null },
        { root: true },
      );
    } catch (err) {
      commit(
        "NotificationModule/SET_STATUS",
        { status: 400, message: `${err.data.message}`, errorCode: null },
        { root: true },
      );
    } finally {
      commit("NotificationModule/TOGGLE_LOADING", false, { root: true });
    }
    return returnRes;
  },
  async requestListDonationHistory({ commit, rootGetters }, filter) {
    commit("NotificationModule/TOGGLE_LOADING", true, { root: true });
    let returnRes = { data: [], total: 0 };
    try {
      const response = await getDonationHistory(
        {
          tokenType: rootGetters["AuthModule/tokenType"],
          accessToken: rootGetters["AuthModule/accessToken"],
        },
        filter,
      );
      commit("SET_LIST_HISTORY", response);
      returnRes =
        response.data !== undefined
          ? { data: response.data.data, total: response.data.total }
          : returnRes;
    } catch (err) {
      commit(
        "NotificationModule/SET_STATUS",
        { status: 400, message: `${err.data.message}`, errorCode: null },
        { root: true },
      );
    } finally {
      commit("NotificationModule/TOGGLE_LOADING", false, { root: true });
    }
    return returnRes;
  },
  async requestListDonationPlan({ commit, rootGetters }) {
    commit("NotificationModule/TOGGLE_LOADING", true, { root: true });
    let returnRes = [];
    try {
      const response = await getListDonationsPlan({
        tokenType: rootGetters["AuthModule/tokenType"],
        accessToken: rootGetters["AuthModule/accessToken"],
      });
      returnRes = response.data !== undefined ? response.data : [];
      commit("SET_LIST_PLAN", response.data !== undefined ? response.data : []);
      commit(
        "NotificationModule/SET_STATUS",
        { status: 200, message: ``, errorCode: null },
        { root: true },
      );
    } catch (err) {
      commit(
        "NotificationModule/SET_STATUS",
        {
          status: err.status,
          message: `${err.data.message}`,
          errorCode: "DonationPlanError",
        },
        { root: true },
      );
    } finally {
      commit("NotificationModule/TOGGLE_LOADING", false, { root: true });
    }
    return returnRes;
  },
  async requestOnGoingAnon({ commit }) {
    commit("NotificationModule/TOGGLE_LOADING", true, { root: true });
    let returnRes = [];
    try {
      const response = await getOnGoingAnon();
      returnRes = response.data !== undefined ? response.data : [];
      commit(
        "SET_LIST_ONGOING_ANON",
        response.data !== undefined ? response.data : [],
      );
      commit(
        "NotificationModule/SET_STATUS",
        { status: 200, message: ``, errorCode: null },
        { root: true },
      );
    } catch (err) {
      commit(
        "NotificationModule/SET_STATUS",
        { status: 400, message: `${err.data.message}`, errorCode: null },
        { root: true },
      );
    } finally {
      commit("NotificationModule/TOGGLE_LOADING", false, { root: true });
    }
    return returnRes;
  },
  async requestDonationReceipt({ commit, rootGetters }, id) {
    commit("NotificationModule/TOGGLE_LOADING", true, { root: true });
    let returnRes = null;
    try {
      const response = await getDonationReceipt(
        {
          tokenType: rootGetters["AuthModule/tokenType"],
          accessToken: rootGetters["AuthModule/accessToken"],
        },
        id,
      );
      returnRes = response;
      commit(
        "NotificationModule/SET_STATUS",
        { status: 200, message: ``, errorCode: null },
        { root: true },
      );
    } catch (err) {
      commit(
        "NotificationModule/SET_STATUS",
        {
          status: 400,
          message: `${err.data.message}`,
          errorCode: "DonationReceiptError",
        },
        { root: true },
      );
    } finally {
      commit("NotificationModule/TOGGLE_LOADING", false, { root: true });
    }
    return returnRes;
  },
};

const mutations = {
  SET_LIST_ONGOING_HOME(state, listOnGoingHome) {
    state.listOnGoingHome = listOnGoingHome;
  },
  SET_LIST_ONGOING_LIST(state, listOnGoingList) {
    state.listOnGoingList = listOnGoingList;
  },
  SET_LIST_ONGOING_ANON(state, listOnGoingAnon) {
    state.listOnGoingAnon = listOnGoingAnon;
  },
  SET_LIST_HISTORY(state, listDonationHistory) {
    state.listDonationHistory = listDonationHistory;
  },
  SET_LIST_PLAN(state, listDonationPlan) {
    state.listDonationPlan = listDonationPlan;
  },
};

export default {
  namespaced: true,
  state: {
    listOnGoingHome: [],
    listOnGoingList: [],
    listDonationHistory: [],
    listDonationPlan: [],
    listOnGoingAnon: [],
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Donations/index.js